function LoadingSpinner({ fullScreen = true }) {
	if (fullScreen) {
		return (
			<div className="fixed inset-0 flex items-center justify-center bg-gray-100 bg-opacity-75 z-50">
				<div className="animate-spin w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full"></div>
			</div>
		);
	}

	return (
		<div className="flex items-center justify-center">
			<div className="animate-spin w-6 h-6 border-4 border-blue-500 border-t-transparent rounded-full"></div>
		</div>
	);
}
export default LoadingSpinner;
